import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-386c4fb6")

_pushScopeId("data-v-386c4fb6")
const _hoisted_1 = { class: "m-page-header" }
const _hoisted_2 = {
  key: 0,
  class: "only-title"
}
const _hoisted_3 = {
  key: 1,
  class: "link-header"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    ($props.type === 'text')
      ? (_openBlock(), _createBlock("h5", _hoisted_2, _toDisplayString($props.title), 1))
      : ($props.type === 'link')
        ? (_openBlock(), _createBlock("h5", _hoisted_3, [
            ($props.router)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: $setup.getRoute($props.router),
                  class: "m-page-header-iconfont icon-fanhui1 back-btn"
                }, null, 8, ["to"]))
              : (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: "m-page-header-iconfont icon-fanhui1 back-btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
                })),
            _createTextVNode(" " + _toDisplayString($props.title), 1)
          ]))
        : _createCommentVNode("", true)
  ]))
})